export const UPLOAD_CONTENT_SECURITY_POLICY =
  "script-src 'none'; frame-src 'none'; object-src 'none'"
